// extracted by mini-css-extract-plugin
export default {"container":"Side_container__eL-mT","menus":"Side_menus__FKxlj"};